import type * as React from 'react';
import type { CheckboxProps } from './types';

const uncheckedIcon =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23CCCCCB' stroke-miterlimit='10' d='M14.8,17H5.2c-1.1,0-2-.9-2-2V5c0-1.1.9-2,2-2h9.6c1.1,0,2,.9,2,2v10c0,1.1-.9,2-2,2z'/%3E%3C/svg%3E\")";
const checkedIcon =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23678272' d='M15.3,18.1H4.7c-1.1,0-2-.9-2-2v-11c0-1.1.9-2,2-2h10.6c1.1,0,2,.9,2,2v11c0,1.1-.9,2-2,2z'/%3E%3Cpolyline fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' points='13.7,8.1 8.7,13.1 6.3,10.7'/%3E%3C/svg%3E\")";
const indeterminateIcon =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23678272' stroke-miterlimit='10' d='M14.8,17.6H5.2c-1.1,0-2-.9-2-2v-10c0-1.1.9-2,2-2h9.6c1.1,0,2,.9,2,2v10c0,1.1-.9,2-2,2z'/%3E%3Cline fill='none' stroke='%23678272' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' x1='7.2' y1='10.6' x2='12.8' y2='10.6'/%3E%3C/svg%3E\")";

const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps, {}) => {
  const updateCallbackWrapper = (callback) => {
    if (!callback) {
      return () => {};
    }

    return (e) => {
      e.preventDefault();
      callback && !props.disabled && callback(props.indeterminate ? true : !props.checked);
    };
  };

  const labelClick = props.onClick ? props.onClick : updateCallbackWrapper(props.updateCallback);
  const icon = props.indeterminate ? indeterminateIcon : props.checked ? checkedIcon : uncheckedIcon;

  return (
    <label
      className={`Form-Checkbox ${props.className || ''} ${props.label ? 'my-1.5 w-auto pt-0.5' : 'my-[3px] mr-[5px] ml-0 w-5'} flex cursor-pointer items-center justify-start leading-[1.2]`}
      onClick={!props.checkboxClickUpdate ? labelClick : undefined}
    >
      <input className="invisible absolute" type="checkbox" checked={props.checked} readOnly={true} />
      <span className={`${props.label ? '-mt-0.5 mr-[5px]' : ''} inline-block h-5 w-5 min-w-5 bg-center bg-no-repeat`} style={{ backgroundImage: icon }} onClick={updateCallbackWrapper(props.checkboxClickUpdate)} />
      {props.label ? (
        <span className="block w-full" onClick={props.checkboxClickUpdate ? labelClick : undefined}>
          {props.label}
        </span>
      ) : null}
    </label>
  );
};

export { Checkbox };
